// extracted by mini-css-extract-plugin
module.exports = {"rotation":"FiltroRadio_rotation__mIlLU"};